import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { FamilyLink } from 'src/app/user/user.model';

@Component({
    selector: 'app-step-members',
    templateUrl: './step-members.component.html',
    styleUrls: ['./step-members.component.scss'],
})
export class StepMembersComponent implements OnDestroy {
    public destroy$ = new Subject();

    @Output() familyMemberClickedEvent = new EventEmitter<FamilyLink>();

    @Input() familyMemberList: FamilyLink[];

    public highlightWarnings: boolean;

    public selectedFamilyMember: FamilyLink;

    familyMemberClicked(value: FamilyLink): void {
        this.familyMemberClickedEvent.emit(value);
        this.selectedFamilyMember = value;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
